export default __webpack_public_path__ + "static/media/active.56636f86.svg";